import { OUTBOUND_REASON_OPTIONS } from "./constants";
import { ReportedAsset } from "../stores/assetManagementStore";

/**
 * Builds the `assets` payload of `assetOutboundConfirmed`.
 *
 * A count can be finished from the missing page or the scan page, so both pages
 * report the same set — shared to keep the two from drifting apart.
 */
export function serialiseReportedAssets(reportedAssets: ReportedAsset[]) {
  return reportedAssets.map((asset) => ({
    asset_id: asset.id,
    asset_state: asset.state,
    reason:
      OUTBOUND_REASON_OPTIONS.find((option) => option.key === asset.state)?.label ?? asset.state,
  }));
}
